import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { account } from '../data/district';
interface AuthUser {
  name: string;
  role: string;
  email: string;
  initials: string;
  firstName: string;
  lastName: string;
}
interface AuthContextValue {
  user: AuthUser;
  updateName: (firstName: string, lastName: string) => void;
}
const AuthContext = createContext<AuthContextValue | undefined>(undefined);
const owner: AuthUser = {
  name: account.name,
  firstName: account.firstName,
  lastName: account.lastName,
  role: account.role,
  email: account.email,
  initials: account.initials
};
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [user, setUser] = useState<AuthUser>(owner);
  const updateName = useCallback((firstName: string, lastName: string) => {
    setUser(prev => ({
      ...prev,
      firstName,
      lastName,
      name: `${firstName} ${lastName}`,
      initials: `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase()
    }));
  }, []);
  const value = useMemo(() => ({
    user,
    updateName
  }), [user, updateName]);
  return <AuthContext.Provider value={value} data-id="element-443" data-mp="2v8t39mkobaak">{children}</AuthContext.Provider>;
}
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}